import uaParser from 'ua-parser-js';
import timeAgo from 'timeago.js';

import { createLogger } from '@/logger';

import friendly from './errors';
import {
  getCurrentUser,
  getAuthenticatedUser,
  attributesToHash,
} from './cognito';

const log = createLogger('auth.session');

function parseSessionsResult(devices) {
  const time = timeAgo().format;
  const sessions = devices.map((dev) => {
    const attrs = attributesToHash(dev.DeviceAttributes);
    const ua = uaParser(attrs.device_name);

    return {
      key: dev.DeviceKey,
      lastIp: attrs.last_ip_used,
      signedIn: attrs.device_status === 'valid',
      lastLogin: dev.DeviceLastAuthenticatedDate,
      lastLoginRelative: time(dev.DeviceLastAuthenticatedDate),
      firstUsed: dev.DeviceCreateDate,
      firstUsedRelative: time(dev.DeviceCreateDate),
      device: {
        os: ua.os.name,
        browser: ua.browser.name,
        browserVersion: ua.browser.major,
        type: ua.device.type,
        model: ua.device.model,
      },
    };
  });

  return sessions.sort((a, b) => a.lastLogin < b.lastLogin);
}

function getListSegment(user, count, token, error, success) {
  user.listDevices(count, token, {
    onFailure: err => error(friendly(err, log)),
    onSuccess: ({ Devices, PaginationToken }) => {
      success({
        sessions: parseSessionsResult(Devices),
        fetchMore: !PaginationToken ? false :
          () => getListSegment(user, count, PaginationToken, error, success),
      });
    },
  });
}

// get user name (guid) synchronously if available.
// Email is not available without async operations.
export function getCurrentUserId() {
  return (getCurrentUser() || {}).username;
}

export function isAuthenticated(cb) {
  getAuthenticatedUser({
    success: ({ session }) => cb(session.isValid()),
    error: () => cb(false),
  });
}

export function getIdToken({ success, error, minValidSeconds }) {
  getAuthenticatedUser({
    minValidSeconds,
    error: err => error(friendly(err, log)),
    success: ({ session }) => {
      log.trace({ message: 'Retrieved new Id token.' });
      success(session.getIdToken().getJwtToken());
    },
  });
}

export function getAccessToken({ success, error, minValidSeconds }) {
  getAuthenticatedUser({
    minValidSeconds,
    error: err => error(friendly(err, log)),
    success: ({ session }) => {
      log.trace({ message: 'Retrieved new Access token.' });
      success(session.getAccessToken().getJwtToken());
    },
  });
}

export function listSessions({ success, error, count }) {
  getAuthenticatedUser({
    error: err => error(friendly(err, log)),
    success: ({ user }) => getListSegment(user, count || 10, null, error, success),
  });
}



// WEBPACK FOOTER //
// ./src/auth/session.js